import { CfgIOManager } from "./CfgIOManager.js";
/**
 * Base class for classes handling input and output in globally shared environments, using
 * event listeners on the window object, for example the History API and window.message API.
 * These are global resources where data not being handled by Stage can appear.
 */
export class CfgWindowEventManager extends CfgIOManager {
    constructor() {
        super(...arguments);
        this._windowEventListenerBound = this._windowEventListener.bind(this);
    }
    /**
     * Listen for the message messageKey being received. This can for example be the history stack
     * being popped or a window.message being received.
     */
    listenForMessage(l, messageKey) {
        const hadListeners = this.hasMessageListeners;
        const didStartListen = super.listenForMessage(l, messageKey);
        if (!hadListeners && didStartListen) {
            window.addEventListener(this.eventType, this._windowEventListenerBound);
        }
        return didStartListen;
    }
    /**
     * Removes the listener
     */
    stopListenForMessage(l) {
        const didStopListen = super.stopListenForMessage(l);
        if (didStopListen && !this.hasMessageListeners) {
            window.removeEventListener(this.eventType, this._windowEventListenerBound);
        }
        return didStopListen;
    }
    _windowEventListener(event) {
        const data = this.getDataFromEvent(event);
        super._containerListener(data);
    }
}
